import React from "react";
import {Nav} from "react-bootstrap";
import "./SearchbarMenu.css"; // Hinzufügen

const SearchbarMenu = ({activeKey, onSelect}) => {
  return (
    <Nav
      variant="pills"
      activeKey={activeKey}
      onSelect={onSelect}
      className="searchbar-menu"
    >
      <Nav.Item>
        <Nav.Link eventKey="single">Einfache Fahrt</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="roundtrip">Hin- und Rückfahrt</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="multiple" disabled>
          Mehrere Routen
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default SearchbarMenu;
